// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"jO-z","carouselContainer":"kO-z"};